import { IQuocTichActionTypes } from "../../action-types/category/IQuocTichActions";
import { IQuocTichReducer } from "../../reducer-model/category/IQuocTichReducer";
import { eReducerStatusBase } from "../../reducer-model/eReducerStatusBase";

const iniState: IQuocTichReducer = {
    status: eReducerStatusBase.is_not_initialization,
    quocTichs: [],
};

export const quocTichReducer = (
 state: IQuocTichReducer = iniState,
 action: IQuocTichActionTypes
): IQuocTichReducer => {
   switch (action.type) {
    case "QUOC_TICH_LOAD_START":
      return {
        ...state,
        status: eReducerStatusBase.is_loading,
      };
    case "QUOC_TICH_LOAD_SUCCESS":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
        quocTichs: action.payload,
      };
    case "QUOC_TICH_LOAD_ERROR":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
      };
    default:
      return state;
  }
};
